import React from "react";
import { cn } from "@/utils/utils";

interface Props {
  children: React.ReactNode;
  onClick?: () => void;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  isActive?: boolean;
  variant?: "soft" | "strong";
  layout?: "default" | "compact";
  className?: string;
  dataTest?: string;
}

const FilterMenuItem = React.forwardRef<HTMLDivElement, Props>(
  (
    {
      children,
      onClick,
      onMouseEnter,
      onMouseLeave,
      isActive = false,
      variant = "soft",
      layout = "default",
      className,
      dataTest
    },
    ref
  ) => {
    const hoverClass =
      variant === "strong"
        ? "hover:bg-surface-hover-strong"
        : "hover:bg-surface-hover-soft";

    const layoutClass =
      layout === "compact" ? "gap-2 p-2" : "justify-between px-3 py-2";

    return (
      <div
        ref={ref}
        data-test={dataTest}
        className={cn(
          "flex items-center cursor-pointer rounded-lg",
          layoutClass,
          hoverClass,
          "active:bg-surface-pressed",
          "transition-all duration-200 ease-in-out",
          isActive && "bg-surface-hover-soft",
          className
        )}
        onClick={onClick}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        {children}
      </div>
    );
  }
);

FilterMenuItem.displayName = "FilterMenuItem";

export default FilterMenuItem;
